import { render, staticRenderFns } from "./getautoras.vue?vue&type=template&id=7302cc60&scoped=true&"
import script from "./getautoras.vue?vue&type=script&lang=js&"
export * from "./getautoras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7302cc60",
  null
  
)

export default component.exports